var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('iframe',{staticClass:"iframe-pct",attrs:{"src":"https://rixtrema.net/pct/","height":"100%","width":"100%"}}),_c('RequestButtonFxd')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }